export default "__VITE_ASSET__fOKaYYYA__"